export default __webpack_public_path__ + "static/media/front.0297f0ba.jpg";